// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"b842397c","787":"b7af92ad"}[chunkId] + ".chunk.js";
};